import React from 'react'
import 'antd/dist/antd.min.css'
import { Modal, Form, Input, Select, notification, Empty } from 'antd'
import { createProject } from "../../../api/project/Project"
import intl from "react-intl-universal"

const { TextArea } = Input
const { Option } = Select
const layout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
}

const params = new URLSearchParams(window.location.search) // 获取URL中参数

class ProjectModel extends React.Component {

    form = React.createRef();

    constructor(props) {
        super(props)
        this.state = {
            visible: params.get('cp') ? true : false, //http://.../?cp=1 其他页面点击“创建项目”按钮，跳转过来默认弹出创建弹窗
            cateDisabled: false,
            confirmLoading: false,
        }

        this.handleModalOkClick = this.handleModalOkClick.bind(this)
        this.submitData = this.submitData.bind(this)
        this.showModal = this.showModal.bind(this)
        this.hideModal = this.hideModal.bind(this)
        this.onReset = this.onReset.bind(this)
    }

    handleModalOkClick () {
        this.form.current.submit()
    }

    // 发送ajax请求
    submitData (params, cb = {}) {
        console.log('submitData', params, this.props)
        let that = this;
        that.setState({
            confirmLoading: true,
        })
        createProject(params).then((res) => {
            // console.log("get projects response:", res);
            that.setState({
                confirmLoading: false,
            })
            if (res.code === 0) {
                notification.open({
                    message: 'Success',
                    description: res.msg,
                })
                // 执行回调函数
                this.props?.callback?.()
                this.hideModal()
            }
        }, (error) => {
            console.log("create failed!")
            that.setState({
                confirmLoading: false,
            })
        }
        )
    };

    render () {
        if (global.auth.canCreatePjCy.length > 0) {
            return this.hasAuthCreate()
        }
        else {
            return (
                <Modal
                    title={intl.get('console.m_p_title')}
                    width={700}
                    visible={this.state.visible}
                    footer={null}
                    onCancel={this.hideModal}>
                    <Empty description="暂无权限创建项目" />
                </Modal>
            )
        }

    }

    hasAuthCreate () {

        let companyOptions = global.auth.canCreatePjCy.map((company) =>
            <Option key={global.auth.companyMap[company].id} value={global.auth.companyMap[company].id}>{global.auth.companyMap[company].name}</Option>
        )

        let serviceOptions = global.serviceList.map((service) => {
            if (service.value < 99) {
                return (<Option key={service.value} value={service.value}>{service.label}</Option>)
            } else {
                return null
            }
        })

        let pjCateOptions = global.pjCateList.map((service) => {
            if (service.value < 99) {
                return (<Option key={service.value} value={service.value}>{service.label}</Option>)
            } else {
                return null
            }
        })

        let rtmRegionOptions = global.rtmRegionList.map((region) =>
            <Option key={region.identifier} value={region.identifier}>{region.name}</Option>
        )


        return (
            <>
                <Modal
                    title={intl.get('console.m_p_title')}
                    width={700}
                    visible={this.state.visible}
                    confirmLoading={this.state.confirmLoading}
                    onOk={this.handleModalOkClick}
                    onCancel={this.hideModal}
                    okText={intl.get('console.m_p_ok')}
                    cancelText={intl.get('console.m_p_cancel')}>

                    <Form {...layout} ref={this.form} name="project" onFinish={this.submitData}>
                        <Form.Item
                            name="name"
                            label={intl.get('console.m_p_name')}
                            rules={[
                                {
                                    required: true,
                                    message: intl.get('console.m_p_name_tips'),
                                },
                            ]}>
                            <Input placeholder={intl.get('console.m_p_name_tips')} />
                        </Form.Item>
                        <Form.Item
                            name="category"
                            label={intl.get('console.m_p_cate')}
                            rules={[
                                {
                                    required: true,
                                    message: intl.get('console.m_p_cate_tips'),
                                },
                            ]}>
                            <Select placeholder={intl.get('console.m_p_cate')} allowClear>
                                {pjCateOptions}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            name="companyId"
                            label={intl.get('console.m_p_company')}
                            rules={[
                                {
                                    required: true,
                                    message: intl.get('console.m_p_company_tips'),
                                },
                            ]}>
                            <Select placeholder={intl.get('console.m_p_company')} allowClear>
                                {companyOptions}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name="service"
                            label={intl.get('console.m_p_service')}
                            rules={[
                                {
                                    required: true,
                                    message: intl.get('console.m_p_service_tips'),
                                },
                            ]}>
                            <Select placeholder={intl.get('console.m_p_service')} allowClear disabled={this.state.cateDisabled}>
                                {serviceOptions}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => prevValues.service !== currentValues.service}
                        >
                            {({ getFieldValue }) =>
                                getFieldValue('service') === 0 ? (
                                    <Form.Item
                                        name="region"
                                        label={intl.get('console.m_p_service_region')}
                                        rules={[
                                            {
                                                required: true,
                                                message: intl.get('console.m_p_service_region_tips'),
                                            },
                                        ]}>
                                        <Select placeholder={intl.get('console.m_p_service_region')} allowClear>
                                            {rtmRegionOptions}
                                        </Select>
                                    </Form.Item>
                                ) : null
                            }
                        </Form.Item>
                        <Form.Item
                            name="description"
                            label={intl.get('console.m_p_desc')}>
                            <TextArea rows={3} placeholder={intl.get('console.m_p_desc')} />
                        </Form.Item>

                    </Form>

                </Modal>
            </>
        )
    }


    onReset () {
        this.form.resetFields()
    };

    showModal (service = '') {
        let that = this
        this.setState({
            visible: true,
        }, function () {
            that.form?.current?.setFieldsValue?.({ service: service })
            if (service >= 0) {
                that.setState({
                    cateDisabled: true,
                })
            } else {
                that.setState({
                    cateDisabled: false,
                })
            }
        })
    };

    hideModal () {
        this.setState({
            visible: false,
        })
    };
}

export default ProjectModel


